var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mr-3",
            attrs: {
              autofocus: "",
              placeholder: "Digite um termo e pressione enter para buscar"
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              }
            },
            model: {
              value: _vm.viewData.search,
              callback: function($$v) {
                _vm.$set(_vm.viewData, "search", $$v)
              },
              expression: "viewData.search"
            }
          }),
          _vm._v(" "),
          _c(
            "BaseButtonComponent",
            { attrs: { to: "/contract/new", variant: "primary-action" } },
            [_vm._v("\n      Novo\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column h-100" },
            [
              _c("v-table", { attrs: { fixedColumns: false } }, [
                _c("thead", [
                  _c("tr", [
                    _c("td", [_vm._v("Nome")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Versão")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Profile")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Status")]),
                    _vm._v(" "),
                    _c("td")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.state.list, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.version))]),
                      _vm._v(" "),
                      _c("td", [
                        item.profile === "consumer"
                          ? _c("span", [_vm._v("Consumidor")])
                          : item.profile === "partner"
                          ? _c("span", [_vm._v("Parceiro")])
                          : item.profile === "investor"
                          ? _c("span", [_vm._v("Investidor")])
                          : item.profile === "trader"
                          ? _c("span", [_vm._v("Comercializador")])
                          : _c("span"),
                        _vm._v(" "),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.active === 1
                          ? _c("span", [_vm._v("Ativo")])
                          : item.active === 0
                          ? _c("span", [_vm._v("Inativo")])
                          : _c("span"),
                        _vm._v(" "),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "right" } },
                        [
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                to: `/contract/edit/${item.id}`,
                                size: "sm",
                                title: "Editar",
                                variant: "primary-action"
                              }
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "pencil-square",
                                  "aria-hidden": "true"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                size: "sm",
                                title: "Excluir",
                                variant: "danger"
                              },
                              on: { click: () => _vm.remove(item) }
                            },
                            [
                              _c("b-icon", {
                                attrs: { icon: "trash", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("b-pagination-nav", {
                staticClass: "mt-3",
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-inline-flex" }, [
      _c("h1", { staticClass: "h2" }, [_vm._v("Contratos")]),
      _vm._v(" "),
      _c("hr", { staticClass: "vertical-bar" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }